import api from '../../utils/api';
import apiformData from '../../utils/apiformData';
import {
  LOGIN,
  LOGOUT,
  GET_AUTH_USER,
  // CHANGE_PASSWORD,
  RESET_PASSWORD,
  UPDATE_AUTH_USER,
  GET_AUTH_PERMISSION,
  // UPDATE_AVATAR,
  GET_BANK,
  ADD_BANK,
  DELETE_BANK,
  SET_DEFAULT_BANK,
} from '../types';
import { setCookie, removeCookie, getCookie } from '../../utils/cookie';
import { NotificationManager } from 'react-notifications';
import api_Oauth2 from '../../utils/api-oauth2';

export const login = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/auth/login', data)
      .then((res) => {
        const hasPermission = ['super', 'admin'].some((role) =>
          res?.data?.data?.user?.roles?.includes(role)
        );
        console.log('res', res);
        if (
          hasPermission ||
          (res?.data?.data?.user?.collaborator?.params &&
            JSON.parse(res?.data?.data?.user?.collaborator?.params)?.role ===
              'admin')
        ) {
          setCookie('token', res.data.access_token, 7);
          dispatch({ type: LOGIN, payload: res.data.data });
          resolve(true);
        } else {
          NotificationManager.error(
            `Vous n'êtes pas autorisé à vous connecter.`
          );
          resolve(true);
        }
      })
      .catch((err) => {
        NotificationManager.error(
          `Nom d'utilisateur ou mot de passe incorrect`
        );
        reject(err);
      });
  });
};

export const getAuthUser = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/auth/loginToken')
      .then((res) => {
        dispatch({ type: GET_AUTH_USER, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        reject(err);
      });
  });
};

export const updateAuthUser = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/client/account/updateProfile', data)
      .then((res) => {
        dispatch({ type: UPDATE_AUTH_USER, payload: res.data.data });
        // console.log('res', res);
        NotificationManager.success('Cập nhật thành công!');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        reject(err);
      });
  });
};

export const changePassword = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api_Oauth2.post('/auth/password', data);

      resolve(true);
    } catch (err) {
      reject(err);
    }
  });
};

export const resetPassword = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/reset-password', data)
      .then((res) => {
        dispatch({ type: RESET_PASSWORD, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        // console.log(err);
        let message = 'Đã có lỗi xảy ra, vui lòng thử lại!';
        if (err.response.data.msg) message = err.response.data.msg;
        NotificationManager.error(message);
        reject(err);
      });
  });
};

export const logout = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    removeCookie('token');
    dispatch({ type: LOGOUT });
    resolve(true);
  });
};

export const getAuthPermission = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/permission/get_all_permission_of_user')
      .then((res) => {
        dispatch({ type: GET_AUTH_PERMISSION, payload: res.data });
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const updateAvatar = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiformData
      .post(`/users/account/update/avatar/${id}`, data)
      .then((res) => {
        dispatch({ type: UPDATE_AUTH_USER, payload: res.data.user });
        resolve(res.data);
        // console.log(res.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const getBank = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/client/account/myBankAccount')
      .then((res) => {
        dispatch({ type: GET_BANK, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const addBank = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post('/client/account/addBankAccount', data)
      .then((res) => {
        dispatch({ type: ADD_BANK, payload: res.data.data });
        NotificationManager.success('Thêm thành công');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const deleteBank = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .delete(`/client/account/deleteBankAccount/${id}`)
      .then((res) => {
        dispatch({ type: DELETE_BANK, payload: res.data.data });
        NotificationManager.success('Cập nhật thành công');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const setDefaultBank = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post(`/client/account/setBankAccountDefault/${id}`)
      .then((res) => {
        dispatch({ type: SET_DEFAULT_BANK, payload: res.data.data });

        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};
